import { Modal } from "react-bootstrap";
import { Wrapper, CustomerShipping } from "../styles";
import { ASSET_URL } from "../constants";

export const ProductsTemplate = ({ order }) => {
  const paymentType = order?.billing.card.brand;
  const paymentLastFour = order?.billing.card.last4;
  const renderProducts = () => {
    return order.products.map((product) => {
      return (
        <div className="product-row">
          <div className="product-image">
            <picture>
              <source srcSet={product.thumbnail} type="image/avif" />
              <img src={product.thumbnail} width="140" />
            </picture>
          </div>
          <div className="product-block">
            <h2>{product.productName}</h2>
            <div className="product-block-row">
              <span className="product-block-label">Design</span>
              <strong className="product-block-value">{product.design}</strong>
            </div>
            <div className="product-block-row">
              <span className="product-block-label">Size</span>
              <strong className="product-block-value">{product.size}</strong>
            </div>
            <div className="product-block-row">
              <span className="product-block-label">Qty</span>
              <strong className="product-block-value">{product.quantity}</strong>
            </div>
            <div className="product-block-row">
              <span className="product-block-label">Price</span>
              <strong className="product-block-value">${product.productCost / 100}</strong>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <Wrapper className="modal-styles">
      <Modal.Header closeButton>
        <Modal.Title>
          Order # <strong>{order.orderNumber}</strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CustomerShipping>
          {order?.shipping && (
            <div>
              <div>
                <strong>Shipping Address</strong>
              </div>
              <div>{order.shipping.name}</div>
              <div>{order.shipping.address.line1}</div>
              {order.shipping.address.line2 && <div>{order.shipping.address.line2}</div>}
              <div>
                {order.shipping.address.city} {order.shipping.address.state} {order.shipping.address.postal_code}{" "}
              </div>
            </div>
          )}
          {order?.billing && (
            <div>
              <div>
                <strong>Billing Details</strong>
              </div>
              <div>{order.billing.name}</div>
              <div>{order.billing.address.line1}</div>
              {order.billing.address.line2 && <div>{order.billing.address.line2}</div>}
              <div>
                {order.billing.address.city} {order.billing.address.state} {order.billing.address.postal_code}{" "}
              </div>
            </div>
          )}
        </CustomerShipping>
        <div className="customer-products box-padding">{renderProducts()}</div>

        <div className="order-footer box-padding">
          <div className="product-row">
            <div className="payment-method">
              <div>
                <strong>Payment Method</strong>
              </div>
              <div>
                {paymentType} ({paymentLastFour})
              </div>
            </div>
            <div className="product-block">
              <div className="product-block-row">
                <span className="product-block-label">Subtotal</span>
                <strong className="product-block-value">${(order.subTotal / 100).toFixed(2)}</strong>
              </div>
              <div className="product-block-row">
                <span className="product-block-label">Shipping</span>
                <strong className="product-block-value">${(order.shippingRate / 100).toFixed(2)}</strong>
              </div>
              {order.salesTax > 0 && (
                <div className="product-block-row">
                  <span className="product-block-label">Sales Tax</span>
                  <strong className="product-block-value">${(order.salesTax / 100).toFixed(2)}</strong>
                </div>
              )}
              <div className="product-block-row">
                <span className="product-block-label">Total</span>
                <strong className="product-block-value">${(order.total / 100).toFixed(2)}</strong>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Wrapper>
  );
};
